// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const DemandArchiveIn = zod.object({
  "reason": zod.enum(['opportunity', 'covered', 'not_relevant'])
});

export type DemandArchiveIn = zod.input<typeof DemandArchiveIn>;
export type DemandArchiveInOutput = zod.output<typeof DemandArchiveIn>;
